module.exports = __webpack_public_path__ + "static/media/Madden_Steve.15246713.png";